import { Paper, Grid } from "@mui/material";
import React from "react";
import "./SportRadarEventCard.scss";
import { NavLink, useParams } from "react-router-dom";
import moment from "moment";
type TableProps = {
  events: any;
};

export const SportRadarEventCard: React.FC<TableProps> = (props) => {
  const { events } = props;
  const { provider } = useParams();
  let gridData =
    events &&
    events &&
    events.filter(
      (itm) =>
        itm.markets.matchOdds.length > 0 &&
        (itm.markets.matchOdds.filter((itm1) => itm1.runners.length > 0)[0]
          ? true
          : false)
    );

  return (
    <Grid container spacing={2} className="grid">
      {gridData && gridData.length ? (
        gridData.map((row) => (
          <Grid item md={4} xs={12} className="grid-item">
            <NavLink
              to={`/lobby/${provider}/${row.sportId}/${row.eventId}/${row.competitionId}`}
              className="navlink"
            >
              <Paper key={row.eventName} className="paper">
                <div className="header">
                  <div className="event">{row.eventName}</div>
                  <div className="date">
                    {row &&
                      row.openDate &&
                      moment(row.openDate).format("DD/MM/YY hh:mm A")}
                  </div>
                </div>
                <div className="card-body">
                  {row &&
                  row.markets &&
                  row.markets.matchOdds &&
                  row.markets.matchOdds.length &&
                  row.markets.matchOdds[0] &&
                  row.markets.matchOdds[0].runners.length > 0 ? (
                    row.markets.matchOdds[0].runners.map((runner, idx) => {
                      return (
                        <div className="odd-box" key={idx}>
                          <div className="runner"> {runner?.runnerName}</div>
                          <div className="odds">
                            {runner?.backPrices?.[0]?.price.toFixed(2)}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="card-body">
                      <div className="odd-box">No Runner</div>
                    </div>
                  )}
                </div>
              </Paper>
            </NavLink>
          </Grid>
        ))
      ) : (
        <>
          <div className="message-empty-container">
            <h5 className="message-empty-message">!!!No Events.!!!</h5>
          </div>
        </>
      )}
    </Grid>
  );
};
